import { toast } from "../../../components/common/toast/ToastProvider";


export function displayToast(message = '', type,  autoClose = {autoClose:false}) {
  return function (dispatch) {
    dispatch({
      type: "TOAST_DISPLAY",
      payload: message,
    });
    toast(message,type, autoClose);
  };
}
